import type { FC } from 'react';
import { useEffect, useState, useTransition } from 'react';
// eslint-disable-next-line no-restricted-imports
import { useFormContext } from 'react-hook-form';

const Listener: FC = () => {
    const [, startTransition] = useTransition();
    const { trigger, watch } = useFormContext();

    const triggerValidation = () => {
        startTransition(() => {
            trigger();
        });
    };

    useEffect(() => {
        const subscription = watch(() => {
            // trigger validation for every change
            triggerValidation();
        });

        // trigger validation after component is mounted
        triggerValidation();

        return () => subscription.unsubscribe();
    }, [watch, startTransition]);

    return null;
};

export const ValidationListener: FC = () => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    if (mounted) {
        return <Listener />;
    }

    return null;
};
